import 'react';
import { BsFillCameraVideoFill } from '@react-icons/all-files/bs/BsFillCameraVideoFill';
import { decorateComponent } from '../../documentComponents/decorateComponent.js';
import { Lottie as Lottie$1 } from './Lottie.js';
import { LottieInspector } from './LottieInspector/LottieInspector.js';
import { jsx } from '@emotion/react';

var Lottie = decorateComponent(Lottie$1, 'block', {
  id: 'lottie',
  label: '로티',
  renderIcon: function renderIcon() {
    return jsx(BsFillCameraVideoFill, null);
  },
  renderInspector: LottieInspector,
  allowedChildren: []
});

export { Lottie as default };
//# sourceMappingURL=index.js.map
